module.exports = __webpack_public_path__ + "img/man.2a21fab1.svg";